export default __webpack_public_path__ + "static/media/snapchat.c0be191e.svg";